import React, { useState } from "react";
import { ZoomMtg } from "@zoom/meetingsdk";
import "../styles/ZoomMeeting.css";
import { getZoomSignature } from "../pages/services/apiService";

ZoomMtg.preLoadWasm();

const ZoomMeetings = () => {
  const [manualZak, setManualZak] = useState("");
  const startMeeting = async () => {
    ZoomMtg.prepareWebSDK();
    const meetingNumber = "86874801127";
    const passWord = "Vu7rjx";
    const sdkKey = process.env.REACT_APP_ZOOM_SDK_KEY;
    // const zakToken = process.env.env.VITE_ZOOM_ZAK_TOKEN;
    const emailId = process.env.REACT_APP_ZOOM_ADMIN_EMAILID;

    const zakToken = manualZak || process.env.REACT_APP_ZOOM_ZAK_TOKEN;

    const data = await getZoomSignature(meetingNumber, 1);

    ZoomMtg.init({
      leaveUrl: window.location.origin,

      success: () => {
        document.getElementById("zmmtg-root").style.display = "block";
        ZoomMtg.join({
          signature: data.signature,
          sdkKey: sdkKey,
          meetingNumber: meetingNumber,
          passWord: passWord,
          userName: "Kuljot",
          userEmail: emailId,
          zak: zakToken,
          success: (res) => console.log("Joined as Host!", res),
          error: (err) => console.log(err),
        });
      },
    });
  };

  return (
    <div className="App">
      <div id="zmmtg-root"></div>
      <div className="host-container">
        <h2>Zoom Host Test</h2>
        <p>Enter ZAK Token to start the session</p>
        <input
          type="text"
          placeholder="Paste fresh ZAK Token here"
          value={manualZak}
          className="input-field"
          onChange={(e) => setManualZak(e.target.value)}
        />
        <br />
        <button className="meeting-start-btn" onClick={startMeeting}>
          Join Class
        </button>
      </div>
    </div>
  );
};

export default ZoomMeetings;
